/* eslint-disable import/no-extraneous-dependencies */

/* eslint-disable react/no-array-index-key */
/* eslint-disable react-hooks/exhaustive-deps */
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Textarea,
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Checkbox,
} from "@repo/ui";
import FormInput from "ui/Input";
import { PATHS } from "routes/paths";
import FormSelect from "ui/select";
import { FormDropdown } from "ui/combo-box";
import Loader from "ui/page-loader";
import { Label } from "ui/label";
import {
  IMS_TYPE,
  INCIDENT_CATEGORIES,
  INCIDENT_TYPES,
  StatusContext,
  TOGGLE,
} from "../constants";
import {
  useLookupGetEmployeeDetail,
  useLookupGetEmployees,
  useLookupGetRegion,
} from "services/lookups";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  useAddNotes,
  useCreateIncidentTicket,
  useDeleteIncidentAttachment,
  useGetIncidentDetails,
  useGetIncidentTicketDetails,
  useUpdateIncidentTicket,
  useUpdateTicket,
} from "services/tickets";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { Trash, Upload } from "lucide-react";
import moment from "moment";
import { FaChrome } from "react-icons/fa";
import { BiUser } from "react-icons/bi";
import { MdEmail } from "react-icons/md";
import {
  disableTicketEditing,
  useGetParentTicketList,
  isCallCenterAgent,
} from "../utils";
import ResolutionNotes from "components/tickets/resolution-notes";
import { useUser } from "hooks/use-user";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { StatusBar } from "components/tickets/status-bar";
import { TicketDetailsHeader } from "components/tickets/ticket-details-header";
import { useGetImageURL } from "services/common";
import { PDFExport } from "@progress/kendo-react-pdf";
import Logo from "../../../assets/images/logo.png";
import { FormLabel } from "@chakra-ui/react";

const emptyTicket = {
  openedBy: "",
  openedFor: "",
  reportedBy: "",
  IMSType: "Standard",
  reportedByTGID: "",
  incidentCategory: "",
  requesterContactNumber: "",
  typeOfIncident: "",
  isCivilDefenseInvolved: "No",
  isPoliceInvolved: "No",
  isMunicipalityInvolved: "No",
  isAmbulanceInvolved: "No",
  isDocInformed: "No",
  isPoliceAssistanceRequested: "No",
  isAmbulanceAssistanceRequested: "No",
  isReportedToCrisisMgmt: "No",
  reportToCrisesManagement: "No",
  newsMediaCoverage: "",
  businessImpact: "",
  incidentDateTime: new Date(),
  noOfInjuries: 0,
  noOfFatalities: 0,
  isTransguardPeople: "No",
  isContractorPeople: "No",
  isThirdPartyPeople: "No",
  peopleOnDuty: "No",
  staffInvolvedName: "",
  region: "",
  staffInvolvedTGID: "",
  location: "",
  staffInvolvedContactNumber: "",
  staffInvolvedDepartment: "",
  staffInvolvedDesignation: "",
  staffInvolvedNationality: "",
  staffInvolvedDetails: {},
  attachments: [],
  remarks: "",
};

const booleanFields = [
  "isCivilDefenseInvolved",
  "isPoliceInvolved",
  "isMunicipalityInvolved",
  "isAmbulanceInvolved",
  "isDocInformed",
  "isPoliceAssistanceRequested",
  "isAmbulanceAssistanceRequested",
  "isReportedToCrisisMgmt",
  "reportToCrisesManagement",
  "isTransguardPeople",
  "isContractorPeople",
  "isThirdPartyPeople",
  "peopleOnDuty",
];

export default function AccidentIncidentReportingDetails() {
  const [ticketDetails, setTicketDetails] = useState({});
  const [imagePreview, setImagePreview] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [isInternal, setIsInternal] = useState(true);
  const { status } = useContext(StatusContext);
  const navigate = useNavigate();
  const params = useParams();
  const user = useUser();
  const isCCA = isCallCenterAgent(user);
  const isCSMAgent = user.Roles.includes("CSM Agent");
  const canEditTicket = user.Roles.includes("Call Center Agent") || isCSMAgent;
  const isCCASupervisor = user.Roles.includes("CC Supervisor");
  const pdfExportComponent = useRef(null);
  const form = useForm({
    defaultValues: { ...emptyTicket },
  });
  const generalProps = {
    errors: form.formState.errors,
    control: form.control,
    hideIcons: true,
  };
  const verificationRules = {
    reportedBy: { required: "Please Enter Value" },
    requesterEmail: { required: "Please Enter Value" },
    priority: { required: "Please Enter Value" },
    region: { required: "Please Enter Value" },
    companyName: { required: "Please Enter Value" },
    remarks: { required: "Please Enter Value" },
    incidentDateTime: { required: "Please Enter Value" },
    category: { required: "Please Enter Value" },
    subCategory: { required: "Please Enter Value" },
    location: { required: "Please Enter Value" },
  };

  const {
    mutate: getTicketDetails,
    data: ticketDetailsRes,
    isPending: gettingTicketDetails,
    reset: restTicketDetails,
  } = useGetIncidentTicketDetails();
  const {
    mutate: getIncidentDetails,
    data: incidentDetailsRes,
    isPending: gettingIncidentDetails,
    reset: restIncidentDetails,
  } = useGetIncidentDetails();
  const {
    mutate: getEmployees,
    data: employeesListRes,
    isPending: gettingEmployeesList,
  } = useLookupGetEmployees();
  const { mutateAsync: getEmployeeDetails, isPending: gettingEmployeeDetail } =
    useLookupGetEmployeeDetail();
  const {
    mutate: getRegion,
    data: regionsListRes,
    isPending: gettingRegionsList,
  } = useLookupGetRegion();
  const {
    mutate: createTicket,
    data: createTicketRes,
    isPending: creatingTicket,
  } = useUpdateIncidentTicket();
  const {
    mutate: addTicketNotes,
    data: addNotesResponse,
    isPending: addingNotes,
    error: addNotesError,
    reset: resetNotesRequest,
  } = useAddNotes();
  const {
    mutate: deleteAttachment,
    data: deleteAttachmentRes,
    reset: resetDeleteAttachment,
  } = useDeleteIncidentAttachment();
  const { mutateAsync: getImageURL } = useGetImageURL();

  useEffect(() => {
    getEmployees();
    getRegion("UAE");

    if (params.ticketId) {
      getTicketDetails(params.ticketId);
    }
  }, []);

  useEffect(() => {
    const subscription = form.watch((value, { name }) => {
      if (name === "openedFor") {
        form.setValue("staffInvolvedRegion", "");
      }
    });
    return () => subscription.unsubscribe();
  }, [form]);

  const reportedForValue = form.watch("openedFor");

  useEffect(() => {
    form.setValue("reportedBy", "");
    form.setValue("reportedByTGID", "");
    form.setValue("reportedByContactNo", "");
  }, [isInternal]);

  useEffect(() => {
    if (reportedForValue) {
      form.setValue("staffInvolvedName", reportedForValue);
    }
    form.setValue("staff");
    onStaffInvolvedChange(reportedForValue);
  }, [reportedForValue]);

  useEffect(() => {
    if (ticketDetailsRes) {
      const reportedByEmployeeId =
        ticketDetailsRes?.data[0]?.reportedBy?.employeeId;
      setIsInternal(reportedByEmployeeId !== null);
    }
  }, [ticketDetailsRes]);

  useEffect(() => {
    if (ticketDetailsRes) {
      const reportedByEmployeeId =
        ticketDetailsRes?.data[0]?.reportedBy?.employeeId;
      setIsInternal(reportedByEmployeeId !== null);
      const details = ticketDetailsRes?.data[0];
      getIncidentDetails(details.requestId);
      restTicketDetails();
    }

    if (incidentDetailsRes) {
      const details = incidentDetailsRes.data;
      const incidentDateTime = details.incidentDateTime
        ? new Date(moment(details.incidentDateTime, "DD-MMM-YYYY hh:mm A"))
        : new Date();

      booleanFields.forEach((elm) => {
        details[elm] = details[elm] ? "Yes" : "No";
      });

      const getImages = async () => {
        if (!details.uploadedFiles || details.uploadedFiles.length === 0)
          return [];
        return Promise.all(
          details.uploadedFiles.map(async (file) => ({
            ...file,
            filePath: await getImageURL(file.filePath),
          }))
        );
      };

      (async () => {
        const images = await getImages();
        setUploadedImages(images);
      })();

      const staffSource =
        details.staffInvolved && Object.keys(details.staffInvolved).length > 0
          ? details.staffInvolved
          : details.openedFor || {};

      const _ticketDetails = {
        ...details,
        IMSType: details.activityType?.split(" ").pop() || "Standard",

        reportedBy: details.reportedBy?.employeeId
          ? details.reportedBy?.employeeId
          : details.reportedBy?.name || "",
        reportedByTGID: details.reportedBy?.tgId || "",
        reportedByContactNo: details.reportedBy?.contactNumber || "",
        reportedByDetails: details.reportedBy
          ? {
              ...details.reportedBy,
              employeeName: details.reportedBy.name,
              id: details.reportedBy.employeeId,
              region: details.reportedBy.region,
              tgId: details.reportedBy.tgId,
              contactNumber: details.reportedBy.contactNumber,
              department: details.reportedBy.department,
              businessUnit: details.reportedBy.businessUnit,
              designation: details.reportedBy.designation,
              nationality: details.reportedBy.nationality,
              email: details.reportedBy.email,
            }
          : {},

        openedFor: details.openedFor?.employeeId || "",
        openedForDetails: details.openedFor
          ? {
              ...details.openedFor,
              employeeName: details.openedFor.name,
              id: details.openedFor.employeeId,
              region: details.openedFor.region,
              tgId: details.openedFor.tgId,
              contactNumber: details.openedFor.contactNumber,
              department: details.openedFor.department,
              businessUnit: details.openedFor.businessUnit,
              designation: details.openedFor.designation,
              nationality: details.openedFor.nationality,
              email: details.openedFor.email,
            }
          : {},

        staffInvolvedTGID: staffSource.tgId || "",
        staffInvolvedName: staffSource.name || "",
        staffInvolvedContactNumber: staffSource.contactNumber || "",
        staffInvolvedDesignation: staffSource.designation || "",
        staffInvolvedDepartment: staffSource.department || "",
        staffInvolvedNationality: staffSource.nationality || "",
        staffInvolvedRegion:
          staffSource.region || details.openedFor?.region || "",
        incidentDateTime,
        attachments: [],
      };

      setTicketDetails(_ticketDetails);
      form.reset({ ..._ticketDetails });
      restIncidentDetails();
    }

    if (addNotesResponse) {
      resetNotesRequest();
      form.resetField("notesRemarks");
      form.resetField("notesAdditionalRemarks");
      getTicketDetails(params.ticketId);
    }
    if (addNotesError) {
      resetNotesRequest();
    }
    if (createTicketRes) {
      navigate(PATHS.accidentIncidentCalls);
    }
    if (deleteAttachmentRes) {
      getTicketDetails(params.ticketId);
      resetDeleteAttachment();
    }
  }, [
    ticketDetailsRes,
    createTicketRes,
    addNotesResponse,
    addNotesError,
    incidentDetailsRes,
    deleteAttachmentRes,
  ]);

  const createPayload = () => {
    // debugger;
    const data = form.getValues();
    const payload = {
      ticketId: ticketDetails.ticketId,
      incidentId: ticketDetails.requestId,
      activityType: `Incident - ${data.IMSType}`,
      category: data.category,
      subCategory: data.subCategory,
      assignmentGroup: "IMS Group",
      creationChannel: "Web",
      priority: data.IMSType === "Emergency" ? 1 : 3,
      openedFor: {
        employeeId: data.openedForDetails.id,
        name: data.openedForDetails.employeeName,
        region: data.staffInvolvedRegion,
        tgId: data.openedForDetails.tgId,
        contactNumber: data.openedForDetails.contactNumber,
        department: data.openedForDetails.department,
        businessUnit: data.openedForDetails.businessUnit,
        designation: data.openedForDetails.designation,
        nationality: data.openedForDetails.nationality,
        email: data.openedForDetails.email,
      },

      reportedBy: {
        employeeId: data.reportedByDetails.id,
        name: data.reportedByDetails.employeeName,
        region: data.reportedByDetails.region,
        tgId: data.reportedByDetails.tgId,
        contactNumber: data.reportedByDetails.contactNumber,
        department: data.reportedByDetails.department,
        businessUnit: data.reportedByDetails.businessUnit,
        designation: data.reportedByDetails.designation,
        nationality: data.reportedByDetails.nationality,
        email: data.reportedByDetails.email,
      },

      isCivilDefenseInvolved: data.isCivilDefenseInvolved === "Yes",
      isPoliceInvolved: data.isPoliceInvolved === "Yes",
      isMunicipalityInvolved: data.isMunicipalityInvolved === "Yes",
      isAmbulanceInvolved: data.isAmbulanceInvolved === "Yes",
      isDocInformed: data.isDocInformed === "Yes",

      isPoliceAssistanceRequested: data.isPoliceAssistanceRequested === "Yes",
      isAmbulanceAssistanceRequested:
        data.isAmbulanceAssistanceRequested === "Yes",
      isReportedToCrisisMgmt: data.isReportedToCrisisMgmt === "Yes",
      newsMediaCoverage: data.newsMediaCoverage,
      businessImpact: data.businessImpact,
      incidentDateTime: data.incidentDateTime,
      noOfInjuries: Number(data.noOfInjuries),
      noOfFatalities: Number(data.noOfFatalities),

      isTransguardPeople: data.isTransguardPeople === "Yes",
      isContractorPeople: data.isContractorPeople === "Yes",
      isThirdPartyPeople: data.isThirdPartyPeople === "Yes",
      peopleOnDuty: data.peopleOnDuty === "Yes",

      location: data.location,
      remarks: data.updatedRemarks,
      additionalRemarks: data.additionalRemarks,
      attachments: data?.attachments || [],
    };
    return payload;
  };
  const onSave = () => {
    createTicket(createPayload());
  };
  const addNotes = () => {
    const payload = {
      remarks: form.getValues("notesRemarks"),
      additionalRemarks: form.getValues("notesAdditionalRemarks"),
      ticketId: form.getValues("ticketId"),
    };
    addTicketNotes(payload);
  };
  const onRequestorChange = async (data) => {
    try {
      const requestorDetailsRes = await getEmployeeDetails(data);
      if (requestorDetailsRes?.data) {
        const requestorDetails = requestorDetailsRes.data;
        form.setValue("reportedByTGID", requestorDetails.tgId);
        form.setValue("reportedByContactNo", requestorDetails.contactNumber);
        form.setValue("reportedByDetails", requestorDetails);
      }
    } catch (e) {}
  };

  const onOpenedForChange = async (data) => {
    try {
      const requestorDetailsRes = await getEmployeeDetails(data);
      if (requestorDetailsRes?.data) {
        const requestorDetails = requestorDetailsRes.data;
        console.log("testing", requestorDetails);
        form.setValue("openedForDetails", requestorDetails);
      }
    } catch (e) {}
  };

  const onStaffInvolvedChange = async (data) => {
    try {
      const requestorDetailsRes = await getEmployeeDetails(data);
      if (requestorDetailsRes?.data) {
        const requestorDetails = requestorDetailsRes.data;
        form.setValue("staffInvolvedTGID", requestorDetails.tgId);
        form.setValue(
          "staffInvolvedContactNumber",
          requestorDetails.contactNumber
        );
        form.setValue("staffInvolvedDepartment", requestorDetails.department);
        form.setValue("staffInvolvedDesignation", requestorDetails.designation);
        form.setValue("staffInvolvedNationality", requestorDetails.nationality);
        // form.setValue("staffInvolvedRegion", "");
        // form.setValue("staffInvolvedDetails", requestorDetails);
      }
    } catch (e) {}
  };
  const onReset = () => {
    form.reset({ ...ticketDetails });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      const attachments = form.getValues("attachments");
      reader.onload = (e) => {
        const base64DataUrl = e.target.result;
        const base64String = base64DataUrl.split(",")[1]; // remove data:image/...;base64,

        const fileObject = {
          fileName: file.name,
          contentType: file.type,
          contents: base64String,
        };

        setImagePreview([...imagePreview, base64DataUrl]);

        form.setValue("attachments", [...attachments, fileObject], {
          shouldDirty: true,
        });

        // For JSON
      };

      reader.readAsDataURL(file); // read file as base64
    }
  };

  const isFormDisabled = useMemo(() => {
    const status = form.watch("status");
    return disableTicketEditing(status);
  }, [form.watch("status")]);

  const exportPDFWithComponent = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };
  console.log("ticket", ticketDetails);

  return (
    <>
      {gettingTicketDetails ||
      gettingEmployeesList ||
      gettingEmployeeDetail ||
      creatingTicket ||
      gettingRegionsList ? (
        <Loader />
      ) : null}

      <div className="form-container">
        <TicketDetailsHeader
          canUpload
          canDownloadTicket
          isFormDisabled={isFormDisabled}
          isDirty={form.formState.isDirty}
          ticket={ticketDetails}
          onSave={form.handleSubmit(onSave)}
          handleFileChange={handleFileChange}
          onReset={onReset}
          onTicketDownload={exportPDFWithComponent}
        />

        <Card className="form-card shadow-lg mx-0">
          <CardHeader>
            <CardTitle>Incident Reporting</CardTitle>
          </CardHeader>
          <Form {...form}>
            <form className="space-y-8 custom-form-v2">
              <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
                <div className="form-row-d-50">
                  <FormInput
                    {...generalProps}
                    name="caseNo"
                    label="TG Reference No"
                    inputProps={{ readOnly: true }}
                  />
                  <FormInput
                    {...generalProps}
                    name="createdBy"
                    label="Opened By"
                    inputProps={{ readOnly: true }}
                  />
                  <FormField
                    // control={form.control}
                    name="internal"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel className="font-sm text-sm">
                          Reported By Employee
                        </FormLabel>
                        <div className="flex items-center gap-2 mb-2">
                          <FormControl>
                            <Checkbox
                              id="internal"
                              checked={isInternal}
                              onCheckedChange={(checked) =>
                                setIsInternal(Boolean(checked))
                              }
                            />
                          </FormControl>
                        </div>
                      </FormItem>
                    )}
                  />
                  <FormInput
                    {...generalProps}
                    name="createDateTime"
                    label="Create Date & Time"
                    inputProps={{ readOnly: true }}
                  />
                  {isInternal ? (
                    <FormDropdown
                      {...generalProps}
                      label="Reported By"
                      name="reportedBy"
                      isRequired
                      data={
                        employeesListRes?.data.map((elm) => ({
                          ...elm,
                          name: `${elm.tgId}-${elm.employeeName}`,
                        })) || []
                      }
                      text="name"
                      id="id"
                      placeholder="Select Employee"
                      rules={verificationRules.reportedBy}
                      onChange={onRequestorChange}
                    />
                  ) : (
                    <FormInput
                      {...generalProps}
                      label="Reported By"
                      name="reportedBy"
                      isRequired
                      rules={verificationRules.reportedBy}
                      inputProps={{ placeholder: "Enter Requester Name" }}
                    />
                  )}{" "}
                  <FormDropdown
                    {...generalProps}
                    label="Reported For"
                    name="openedFor"
                    isRequired
                    data={
                      employeesListRes?.data.map((elm) => ({
                        ...elm,
                        name: `${elm.tgId}-${elm.employeeName}`,
                      })) || []
                    }
                    text="name"
                    id="id"
                    placeholder="Select Employee"
                    rules={verificationRules.openedFor}
                    onChange={onOpenedForChange}
                  />
                  <FormInput
                    {...generalProps}
                    isRequired
                    name="reportedByTGID"
                    label="Requester TGID"
                    inputProps={{ readOnly: true }}
                    rules={verificationRules.reportedByTGID}
                  />{" "}
                  <FormSelect
                    {...generalProps}
                    isRequired
                    name="IMSType"
                    label="IMS Type"
                    placeholder="Select Type"
                    data={IMS_TYPE}
                    id="id"
                    text="text"
                    rules={verificationRules.IMSType}
                  />
                  <FormInput
                    {...generalProps}
                    isRequired
                    name="reportedByContactNo"
                    label="Requester Contact No"
                    inputProps={{
                      readOnly: Boolean(isInternal),
                      placeholder: isInternal
                        ? ""
                        : "Enter Requester Contact No",
                    }}
                  />
                  <FormDropdown
                    {...generalProps}
                    isRequired
                    label="Incident Category"
                    name="category"
                    placeholder="Select Category"
                    data={INCIDENT_CATEGORIES}
                    id="id"
                    text="text"
                    rules={verificationRules.category}
                  />
                  <FormDropdown
                    {...generalProps}
                    isRequired
                    name="subCategory"
                    label="Type of Incident"
                    placeholder="Select Type"
                    data={INCIDENT_TYPES}
                    rules={verificationRules.subCategory}
                    id="id"
                    text="text"
                  />
                </div>
                <Accordion
                  type="multiple"
                  defaultValue={[
                    "externalAgencies",
                    "requestedAssistance",
                    "people",
                    "staffInvolved",
                  ]}
                  collapsible
                  className="w-full"
                >
                  <AccordionItem value="externalAgencies" className="w-full">
                    <div>
                      <AccordionTrigger
                        className="bg-transparent"
                        style={{ background: "transparent" }}
                      >
                        External Agencies Involved
                      </AccordionTrigger>
                    </div>

                    <AccordionContent className="w-full">
                      <div className="form-row-d-50">
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="isCivilDefenseInvolved"
                          label="Civil Defense"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="isPoliceInvolved"
                          label="Police"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="isMunicipalityInvolved"
                          label="Municipality"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="text"
                          text="text"
                        />
                        {form.watch("IMSType") === "Emergency" ? (
                          <>
                            <FormSelect
                              {...generalProps}
                              isRequired
                              name="isAmbulanceInvolved"
                              label="Ambulance"
                              placeholder="Select Value"
                              data={TOGGLE}
                              id="id"
                              text="text"
                            />
                            <FormSelect
                              {...generalProps}
                              isRequired
                              name="isDocInformed"
                              label="DOC Informed"
                              placeholder="Select Value"
                              data={TOGGLE}
                              id="id"
                              text="text"
                            />
                          </>
                        ) : null}
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                  <AccordionItem value="requestedAssistance" className="w-full">
                    <div>
                      <AccordionTrigger
                        className="bg-transparent"
                        style={{ background: "transparent" }}
                      >
                        What Assistance has been Requested
                      </AccordionTrigger>
                    </div>

                    <AccordionContent className="w-full">
                      <div className="form-row-d-50">
                        <FormSelect
                          {...generalProps}
                          isRequired
                          label="Police"
                          name="isPoliceAssistanceRequested"
                          placeholder="Select Value"
                          data={TOGGLE}
                          text="text"
                          id="id"
                        />
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="isAmbulanceAssistanceRequested"
                          label="Ambulance"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                        <FormSelect
                          {...generalProps}
                          name="isReportedToCrisisMgmt"
                          label="Report To Crises Management"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                        <FormInput
                          {...generalProps}
                          name="newsMediaCoverage"
                          label="News of Media Coverage"
                        />
                        <FormInput
                          {...generalProps}
                          name="businessImpact"
                          label="Business Impact,Damage or Loss"
                        />
                        <FormField
                          control={generalProps.control}
                          name="incidentDateTime"
                          // rules={rules ? { ...rules } : {}}
                          render={({ field }) => (
                            <FormItem>
                              <Label
                                label="Date & Time of Incident"
                                isRequired
                              />
                              <FormControl>
                                <div className="form-date-picker">
                                  <DateTimePicker
                                    variant="secondary"
                                    className="px-3 py-2 border border-input"
                                    value={field.value}
                                    placeholder="Select Date"
                                    onChange={(e) => {
                                      field.onChange(e.target.value);
                                    }}
                                  />
                                </div>
                              </FormControl>{" "}
                            </FormItem>
                          )}
                        />

                        <FormInput
                          {...generalProps}
                          name="noOfInjuries"
                          label="No. of Injuries"
                          inputProps={{ type: "number" }}
                        />
                        <FormInput
                          {...generalProps}
                          name="noOfFatalities"
                          label="No. of Fatalities"
                          inputProps={{ type: "number" }}
                        />
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                  <AccordionItem value="people" className="w-full">
                    <div>
                      <AccordionTrigger
                        className="bg-transparent"
                        style={{ background: "transparent" }}
                      >
                        People
                      </AccordionTrigger>
                    </div>

                    <AccordionContent className="w-full">
                      <div className="form-row-d-50">
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="isTransguardPeople"
                          label="Transguard"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="isContractorPeople"
                          label="Contractor"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="isThirdPartyPeople"
                          label="Third Party"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="peopleOnDuty"
                          label="Is On Duty"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                  <AccordionItem value="staffInvolved" className="w-full">
                    <div>
                      <AccordionTrigger
                        className="bg-transparent"
                        style={{ background: "transparent" }}
                      >
                        Staff Involved Information
                      </AccordionTrigger>
                    </div>

                    <AccordionContent className="w-full">
                      <div className="form-row-d-50">
                        <FormDropdown
                          {...generalProps}
                          label="Staff Involved Name"
                          name="staffInvolvedName"
                          isRequired
                          disabled
                          data={
                            employeesListRes?.data.map((elm) => ({
                              ...elm,
                              name: `${elm.tgId}-${elm.employeeName}`,
                            })) || []
                          }
                          text="name"
                          id="id"
                          placeholder="Select Employee"
                          rules={verificationRules.reportedBy}
                          onChange={onStaffInvolvedChange}
                        />

                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="staffInvolvedRegion"
                          label="Region"
                          placeholder="Select Region"
                          data={regionsListRes?.data || []}
                          id="name"
                          text="name"
                          rules={verificationRules.region}
                        />
                        <FormInput
                          {...generalProps}
                          name="staffInvolvedTGID"
                          label="Staff Involved TGID"
                          disabled
                        />
                        <FormInput
                          {...generalProps}
                          isRequired
                          label="Location"
                          name="location"
                          rules={verificationRules.location}
                        />

                        <FormInput
                          {...generalProps}
                          name="staffInvolvedContactNumber"
                          label="Staff Involved Contact No."
                          disabled
                        />
                        <FormInput
                          {...generalProps}
                          name="staffInvolvedDesignation"
                          label="Staff Involved Designation"
                          disabled
                        />
                        <FormInput
                          {...generalProps}
                          name="staffInvolvedNationality"
                          label="Staff Involved Nationality"
                          disabled
                        />
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="remarks"
                    rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Purpose of Call"
                            isRequired
                            style={{
                              justifyContent: "flex-start",
                              textAlign: "left",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                disabled={!isCCA || !isCSMAgent}
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {/* {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : null} */}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="updatedRemarks"
                    rules={{
                      required:
                        "Remarks field is required. Please enter your remarks.",
                      validate: (value) =>
                        value && value.trim().length > 0
                          ? true
                          : "Remarks field cannot be empty.",
                    }}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Remarks"
                            isRequired
                            style={{ justifyContent: "start" }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                disabled={!canEditTicket}
                                style={
                                  form.formState?.errors?.updatedRemarks
                                    ? { borderColor: "red" }
                                    : {}
                                }
                              />
                            </FormControl>

                            {form.formState?.errors?.updatedRemarks ? (
                              <p className="text-destructive text-xs mt-1">
                                {form.formState.errors.updatedRemarks.message}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="additionalRemarks"
                    // rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Additional Remarks"
                            // isRequired={true}
                            style={{
                              justifyContent: "start",
                              textAlign: "left",
                              width: "100%",
                              textWrap: "nowrap",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                disabled={!canEditTicket}
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.additionalRemarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.additionalRemarks ? (
                              <p className="text-destructive text-xs">
                                {
                                  form.formState.errors.additionalRemarks
                                    .message
                                }
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <Tabs
                  defaultValue="notes"
                  className="w-full form-container-tabs"
                  variant="secondary"
                >
                  <TabsList
                    className="w-full justify-start"
                    style={{ justifyContent: "flex-start" }}
                  >
                    <TabsTrigger value="notes">Notes</TabsTrigger>

                    <TabsTrigger value="attachments">Attachments</TabsTrigger>
                    <TabsTrigger value="requestDetails">
                      Request Details
                    </TabsTrigger>
                    <TabsTrigger value="accessTiming">
                      Access Timings
                    </TabsTrigger>
                    <TabsTrigger value="denomination">Denomination</TabsTrigger>
                    <TabsTrigger value="resolutionInformation">
                      Resolution Information
                    </TabsTrigger>
                    <TabsTrigger value="System">system</TabsTrigger>
                  </TabsList>

                  <TabsContent value="notes">
                    {form.watch("status") !== "Closed" &&
                    form.watch("status") !== "Cancelled" ? (
                      <>
                        {isCCA || isCSMAgent ? (
                          <>
                            <FormField
                              control={form.control}
                              name="notesRemarks"
                              render={({ field }) => (
                                <FormItem>
                                  <Label label="Work Notes" />

                                  <FormControl>
                                    <Textarea
                                      {...field}
                                      className="border-secondary"
                                      style={{ marginBottom: "16px" }}
                                    />
                                  </FormControl>
                                </FormItem>
                              )}
                            />
                            <FormField
                              control={form.control}
                              name="notesAdditionalRemarks"
                              render={({ field }) => (
                                <FormItem>
                                  <Label label="Additional Comments" />
                                  <FormControl>
                                    <Textarea
                                      {...field}
                                      className="border-secondary mb-4"
                                      style={{ marginBottom: "16px" }}
                                    />
                                  </FormControl>
                                </FormItem>
                              )}
                            />

                            <div className="flex flex-row w-full justify-end">
                              <Button variant="secondary" onClick={addNotes}>
                                Post
                              </Button>
                            </div>
                          </>
                        ) : null}
                      </>
                    ) : null}

                    {form.watch("logs")?.map((elm, index) => {
                      return (
                        <Card
                          className="px-2 py-4 my-2 shadow-none rounded-lg  justify-between flex flex-row gap-8"
                          key={index}
                        >
                          <div className="flex flex-col gap-2 max-w-[70%]">
                            <p className="font-medium text-md">
                              Action: {elm.operation}
                            </p>

                            <p className="font-normal text-md">
                              <span className="font-medium"> Notes: </span>
                              {elm.remarks}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium">Comments: </span>
                              {elm.additionalRemarks}
                            </p>
                          </div>
                          <div className="flex flex-col gap-2">
                            <p className="font-normal text-md">
                              <span className="font-medium">Updated By:</span>
                              &nbsp;
                              {elm.user}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium"> Updated At: </span>
                              {elm.operationTime}
                            </p>
                          </div>
                        </Card>
                      );
                    })}
                  </TabsContent>

                  <TabsContent value="attachments">
                    {" "}
                    <div className="form-row-d-50">
                      {uploadedImages?.map((elm, index) => (
                        <div
                          className="border border-solid-secondary relative w-[200px] h-[200px"
                          key={index}
                        >
                          {isCCASupervisor ? (
                            <Button
                              className="absolute top-1 right-2 z-[1]"
                              variant="secondary"
                              type="button"
                              onClick={() => {
                                deleteAttachment({
                                  incidentId: form.getValues("requestId"),
                                  filedId: elm.id,
                                });
                              }}
                            >
                              <Trash />
                            </Button>
                          ) : null}

                          <a
                            href={elm.filePath}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              className="] object-contain"
                              src={elm.filePath}
                              alt="preview"
                            />
                          </a>
                        </div>
                      ))}
                      {imagePreview?.map((elm, index) => (
                        <div
                          className="border border-solid-secondary relative w-[200px] h-[200px"
                          key={index}
                        >
                          <Button
                            className="absolute top-1 right-2 z-[1]"
                            variant="secondary"
                            type="button"
                            onClick={() => {
                              const attachments = imagePreview;

                              attachments.splice(index, 1);
                              form.setValue("attachments", attachments, {
                                shouldDirty: true,
                              });
                              setImagePreview([...attachments]);
                            }}
                          >
                            <Trash />{" "}
                          </Button>{" "}
                          <a
                            href={elm}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              className="] object-contain"
                              src={elm}
                              alt="preview"
                            />
                          </a>
                        </div>
                      ))}
                    </div>
                  </TabsContent>
                  <TabsContent value="requestDetails">Coming Soon</TabsContent>
                  <TabsContent value="accessTiming">Coming Soon</TabsContent>
                  <TabsContent value="denomination">Coming Soon</TabsContent>
                  <TabsContent value="resolutionInformation">
                    Coming Soon
                  </TabsContent>
                  <TabsContent value="system">Coming Soon</TabsContent>
                </Tabs>
              </CardContent>
              <div
                style={{ position: "absolute", left: "-100000000px", top: 0 }}
              >
                {" "}
                <PDFExport
                  ref={pdfExportComponent}
                  paperSize="auto"
                  margin={{ top: 40, left: 20, right: 20, bottom: 40 }}
                  fileName={`Incident Ticket Details for ${ticketDetails.caseNo}`}
                  author="LYNX"
                >
                  <table width="100%" className="table-layout">
                    <thead>
                      <tr>
                        <th width="15%" />
                        <th width="70%" />
                        <th width="15%" />
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        style={{
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                        }}
                      >
                        <td
                          style={{
                            padding: 4,
                          }}
                        >
                          <img
                            src={Logo}
                            alt="log"
                            style={{
                              height: "100%", // h-full
                              objectFit: "contain", // object-contain
                            }}
                          />
                        </td>
                        <td>
                          <h1 style={{ textAlign: "center" }}>
                            Transguard Group
                            <br />
                            MAJOR/MINOR INCIDENT ANNOUNCEMENT
                          </h1>
                        </td>
                        <td>
                          <div className="flex flex-col items-end">
                            <p>Ref:FRM-HSE-074</p>
                            <p>Ver 1.0 / Date 27 JAN 23</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table width="100%" className="mt-4 table-layout">
                    <thead>
                      <tr>
                        <th width="15%" />
                        <th width="5%" />
                        <th width="80%" />
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <h1 className="font-bold">Report Title:</h1>
                        </td>
                        <td />
                        <td>Interaction Details</td>
                      </tr>
                      <tr>
                        <td>
                          <h1 className="font-bold">Run Date and Time:</h1>
                        </td>
                        <td />
                        <td>{ticketDetails.createDateTime}</td>
                      </tr>
                      <tr>
                        <td>
                          <h1 className="font-bold">Run by:</h1>
                        </td>
                        <td />
                        <td>System Administrator</td>
                      </tr>
                      <tr>
                        <td>
                          <h1 className="font-bold">Table Name:</h1>
                        </td>
                        <td />
                        <td>Interaction</td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    width="100%"
                    className="table-layout table-border-white"
                  >
                    <thead>
                      <tr>
                        <th width="25%" />
                        <th width="25%" />
                        <th width="25%" />
                        <th width="25%" />
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan={4} className="bg-[#659bcf] text-white">
                          Interaction
                        </td>
                      </tr>
                      <tr>
                        <td className="bg-[#dfdfdf] ">Reference Number:</td>
                        <td>{ticketDetails.caseNo}</td>
                        <td className="bg-[#dfdfdf] ">Reported By:</td>
                        <td>
                          {ticketDetails.reportedByDetails?.employeeName ||
                            "N/A"}
                        </td>
                      </tr>

                      <tr>
                        <td className="bg-[#dfdfdf] ">Opened For:</td>
                        <td>
                          {ticketDetails.openedForDetails?.employeeName ||
                            "N/A"}
                        </td>
                        <td className="bg-[#dfdfdf] ">TGID:</td>
                        <td>{ticketDetails.openedForDetails?.tgId || "N/A"}</td>
                      </tr>
                      <tr>
                        <td className="bg-[#dfdfdf] ">Country:</td>
                        <td>United Arab Emirates</td>
                        <td className="bg-[#dfdfdf] ">Business Unit:</td>
                        <td>
                          {ticketDetails.openedForDetails?.businessUnit ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td className="bg-[#dfdfdf] ">Contact:</td>
                        <td>Transguard Group LLC</td>
                        <td className="bg-[#dfdfdf] ">Contact Number:</td>
                        <td>
                          {ticketDetails.openedForDetails?.contactNumber ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td className="bg-[#dfdfdf] ">Created:</td>
                        <td>{ticketDetails.createDateTime || "N/A"}</td>
                        <td className="bg-[#dfdfdf] ">Reported By Email:</td>
                        <td>
                          {ticketDetails.reportedByDetails?.email || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td className="bg-[#dfdfdf] ">Incident Location:</td>
                        <td>{ticketDetails.location || "N/A"}</td>
                        <td className="bg-[#dfdfdf] ">
                          Date/Time of Incident:
                        </td>
                        <td>
                          {ticketDetails.incidentDateTime
                            ? moment(ticketDetails.incidentDateTime).format(
                                "DD-MM-YYYY HH:MM"
                              )
                            : "N/A"}
                        </td>
                      </tr>

                      <tr>
                        <td className="bg-[#dfdfdf] " colSpan="4">
                          Incident Description:
                        </td>{" "}
                      </tr>
                      <tr>
                        <td colSpan="4">{ticketDetails.remarks || "N/A"}</td>
                      </tr>
                      <tr>
                        <td colSpan={4} className="bg-[#659bcf] text-white">
                          Additional Information
                        </td>
                      </tr>
                      <tr>
                        <td className="bg-[#dfdfdf] ">
                          Business Impact/Damage/Loss:
                        </td>
                        <td>{ticketDetails.businessImpact || "N/A"}</td>
                        <td className="bg-[#dfdfdf] ">
                          Report To Crises Management Group?
                        </td>
                        <td>{ticketDetails.isReportedToCrisisMgmt || "N/A"}</td>
                      </tr>
                      <tr>
                        <td className="bg-[#dfdfdf] ">No. of Injuries:</td>
                        <td>{ticketDetails.noOfInjuries || "N/A"}</td>
                        <td className="bg-[#dfdfdf] ">No. of Fatalities:</td>
                        <td>{ticketDetails.noOfFatalities || "N/A"}</td>
                      </tr>
                      <tr>
                        <td className="bg-[#dfdfdf] ">Incident Category:</td>
                        <td>{ticketDetails.category || "N/A"}</td>
                        <td className="bg-[#dfdfdf] ">Type of Incident:</td>
                        <td>{ticketDetails.subCategory || "N/A"}</td>
                      </tr>
                      <tr>
                        <td className="bg-[#dfdfdf] ">News Media Coverage:</td>
                        <td>{ticketDetails.newsMediaCoverage || "N/A"}</td>
                        <td className="bg-[#dfdfdf] ">On/Off Duty:</td>
                        <td>
                          {ticketDetails.peopleOnDuty === "Yes"
                            ? "On Duty"
                            : "Off Duty"}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={4} className="bg-[#659bcf] text-white">
                          People
                        </td>
                      </tr>
                      <tr>
                        <td className="bg-[#dfdfdf] ">Transguard:</td>
                        <td>{ticketDetails.isTransguardPeople}</td>
                        <td className="bg-[#dfdfdf] ">Third Party:</td>
                        <td>{ticketDetails.isThirdPartyPeople}</td>
                      </tr>
                      <tr>
                        <td className="bg-[#dfdfdf] ">Contractor:</td>
                        <td>{ticketDetails.isContractorPeople}</td>
                      </tr>
                      <tr>
                        <td colSpan={4} className="bg-[#659bcf] text-white">
                          External Agencies Involved
                        </td>
                      </tr>
                      <tr>
                        <td className="bg-[#dfdfdf] ">Civil Defense:</td>
                        <td>{ticketDetails.isCivilDefenseInvolved}</td>
                        <td className="bg-[#dfdfdf] ">Dubai Municipality:</td>
                        <td>{ticketDetails.isMunicipalityInvolved}</td>
                      </tr>
                      <tr>
                        <td className="bg-[#dfdfdf] ">Police:</td>
                        <td>{ticketDetails.isPoliceInvolved}</td>
                        <td className="bg-[#dfdfdf] ">Ambulance:</td>
                        <td>{ticketDetails.isAmbulanceInvolved}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td className="bg-[#dfdfdf] ">
                          DOC Informed (Contact 8001444):
                        </td>
                        <td>{ticketDetails.isDocInformed}</td>
                      </tr>
                      <tr>
                        <td colSpan={4} className="bg-[#659bcf] text-white">
                          What Assistance has been Requested
                        </td>
                      </tr>
                      <tr>
                        <td className="bg-[#dfdfdf] ">Police:</td>
                        <td>{ticketDetails.isPoliceAssistanceRequested}</td>
                        <td className="bg-[#dfdfdf] ">Ambulance:</td>
                        <td>{ticketDetails.isAmbulanceAssistanceRequested}</td>
                      </tr>
                      <tr>
                        <td className="bg-[#dfdfdf] ">Closed:</td>
                        <td>{ticketDetails.closedDateTime || "N/A"}</td>
                        <td className="bg-[#dfdfdf] ">Closed By:</td>
                        <td>{ticketDetails.closedBy || "N/A"}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td className="bg-[#dfdfdf] ">Closed By TGID:</td>
                        <td>{ticketDetails.closedByTgId || "N/A"}</td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    width="100%"
                    className="table-layout"
                    style={{ marginTop: "150px", borderTop: "1px solid black" }}
                  >
                    <thead>
                      <tr>
                        <th width={`${100 / 3}%`}></th>
                        <th width={`${100 / 3}%`}></th>
                        <th width={`${100 / 3}%`}></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div className="flex flex-col">
                            <p className="font-bold">
                              E-mails to be distributed to your HSE
                            </p>
                            <p className="font-bold">
                              Department: hse@transguardgroup.com
                            </p>
                          </div>
                        </td>
                        <td>
                          <div className="flex flex-col items-center">
                            <p className="font-bold">
                              It is the responsibility of the sender to contact
                              the
                            </p>
                            <p className="font-bold">
                              HSE that they have received the e-mail.
                            </p>
                          </div>
                        </td>
                        <td>
                          <div className="flex flex-col items-end justify-end">
                            <p className="font-bold hidden">
                              For any queries, please contact DOC at 8001444
                            </p>
                            <p className="font-bold">
                              For any queries, please contact DOC at 8001444
                            </p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </PDFExport>
              </div>
            </form>
          </Form>
        </Card>
      </div>
    </>
  );
}
